module.exports = __webpack_public_path__ + "assets/img/101302.342b1daf.svg";